// extracted by mini-css-extract-plugin
export default {"ratioBarBase":"RatioBar_ratioBarBase__O2Rf8","ratioBarContent":"RatioBar_ratioBarContent__Ums2p"};